module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_60_Inactive@1x-d1b999c7953b39e92cbe4096fd858ef7.png";